<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RqeaM4/tc-custom/9781429940535.jpg?1744296842058" alt="This image is the cover for the book Chihuahua of the Baskervilles, Tripping Magazine Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chihuahua of the Baskervilles, Tripping Magazine Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><i>When the glowing form of a beloved deceased Chihuahua appears, is it a ghost, or is </i><i>someone teaching a dead dog new tricks – like murder?</i><br/><br/><br/><br/><i>Tripping Magazine </i>is a quirky low-budget magazine that reports on travel destinations for believers in the paranormal. A few fake ghosts away from throwing in the towel, the <i>Tripping </i>staff get the tip of a lifetime when they get a call from Charlotte Baskerville, the rich founder of a clothing company for small dogs. Charlotte thinks that her Chihuahua, Petey, has come back from the dead, and she's desperate for someone to come verify his appearances. <br/><br/>The magazine's three-person reporting team travels to Manitou Springs, Colorado, sure that the ghostly dog will be a work of fiction. But, when they arrive, they see evidence of Petey with their own eyes. And he's not just floating by – he's howling advice and spelling out threats with tiny paw prints. Is the ghost real, or is the whole phenomenon an elaborate ruse? <br/><br/>The <i>Tripping </i>team must navigate the kooky world of coffin races, scheming husbands, and doggie fashion to solve the mystery – and get their story written at the same time. Uproariously funny and a great mystery to boot, <i>Chihuahua of the Baskervilles </i>is sure to leave you in stitches.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Esri Allbritten
      </h2>
      
      <p class="authorDescription body article"><P>ESRI ALLBRITTEN is a former copywriter for radio and TV ads. She enjoys singing and songwriting and she lives in Boulder, Colorado.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?798af45a